var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboriginalFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 905 610",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m292.33 455.73c1.232-1.1218 13.833-11.452 28.001-22.957 14.169-11.504 26.604-21.634 27.633-22.51 1.0298-0.87602-5.3077-23.511-14.083-50.3-17.103-52.211-20.415-70.575-17.68-98.024 2.0912-20.984 12.445-41.248 28.839-56.443 18.783-17.41 50.169-35.132 81.998-46.301l11.502-4.0362 6.158 31.187c3.3869 17.153 6.8082 31.187 7.6029 31.187 0.7947 0 4.3192-14.029 7.8323-31.176l6.3874-31.176 11.469 4.0248c31.796 11.158 63.19 28.888 81.964 46.289 16.394 15.195 26.747 35.459 28.839 56.443 2.7355 27.449-0.57678 45.814-17.68 98.024-8.7755 26.789-15.113 49.424-14.083 50.3 1.0298 0.87604 13.465 11.005 27.633 22.51 14.169 11.504 26.769 21.835 28.001 22.957 2.1878 1.992-3.2219 0.10096-66.643-23.296l-30.801-11.363v-65.998c0-74.388 0.3415-72.627-17.053-87.955-24.428-21.527-66.912-21.527-91.34 0-17.394 15.328-17.053 13.567-17.053 87.955v65.998l-30.801 11.363c-63.421 23.397-68.831 25.288-66.643 23.296zm131.17-105.12c3.6285-10.747 6.5612-20.612 6.5172-21.922-0.04402-1.3104-8.0635-7.9332-17.821-14.717l-17.741-12.335 45.448-2.2426 6.8122-20.876 6.8122-20.876 13.893 41.751 44.406 2.2426-16.784 12.1c-9.231 6.6551-17.145 12.399-17.587 12.765-0.44204 0.36587 2.3188 9.9859 6.1351 21.378 3.8163 11.392 6.6981 20.946 6.4039 21.23-0.29417 0.28472-8.5439-5.307-18.333-12.426l-17.798-12.944-15.804 11.62c-8.692 6.391-17.008 12.333-18.481 13.205-1.4795 0.87567 0.27409-7.1562 3.9202-17.955z",
    fill: "#fdfdfe",
    id: "path1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 2,
    width: 906,
    height: 608,
    fill: "#c00",
    id: "rect1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -3.8106e-7,
    width: 906,
    height: 306,
    id: "rect2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 452,
    cy: 306,
    r: 135.9,
    fill: "#ff0",
    id: "circle2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboriginalFlag);
export default __webpack_public_path__ + "static/media/aboriginal-flag.9be3ec615695f2171e2d16bc8c74e04a.svg";
export { ForwardRef as ReactComponent };